<wizard #wizard navBarLayout="large-empty-symbols">

  <wizard-step stepTitle="Start" navigationSymbol="&#xf015;" navigationSymbolFontFamily="FontAwesome">
    <div class="centered-content">
      <div class="container">
        <div class="py-5 text-center">
          <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
          <h3>Return of Investment berechnen</h3>
          <p class="lead">
            <!--Hier kann dann ein Einleitungstext stehen der noch genau definiert werden muss usw.-->
          </p>
          <button class="btn btn-primary" nextStep="">Starte Berechnung</button>
        </div>
      </div>
    </div>
  </wizard-step>

  <wizard-step stepTitle="Zeitersparung" navigationSymbol="&#xf251;" navigationSymbolFontFamily="FontAwesome">
    <div class="container">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
      </div>
      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <ngb-accordion [closeOthers]="true" activeIds="static-1">
            <ngb-panel id="static-1" title="Ergebnis">
              <ng-template ngbPanelContent>
                Ihre Organistation könnte bei den einzelnen Tätigkeiten monatlich folgende Zeit einsparen:
                <div class="row pt-1">
                  <div class="col-md-4 left">Ablage:</div>
                  <div class="col-md-8 right">{{ filedHour }} Stunden {{ filedMinute }} Minuten</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Suchen:</div>
                  <div class="col-md-8 right">{{ searchHour }} Stunden {{ searchMinute }} Minuten</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Kopieren:</div>
                  <div class="col-md-8 right">{{ copyHour }} Stunden {{ copyMinute }} Minuten</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Verteilen:</div>
                  <div class="col-md-8 right">{{ anzMemberHour }} Stunden {{ anzMemberMinute }} Minuten</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Reproduz.:</div>
                  <div class="col-md-8 right">{{ anzRestoreHour }} Stunden {{ anzRestoreMinute }} Minuten</div>
                </div>
                <div class="row pt-3">
                  <div class="col-md-4 left font-weight-bold">Summe:</div>
                  <div class="col-md-8 right font-weight-bold">{{ sumHour }} Stunden  {{ sumMinute }} Minuten</div>
                </div>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="static-2" title="So wird gerechnet">
              <ng-template ngbPanelContent>
                <p class="row pl-2">Zeiteinsparung beim Ablegen, Suchen, Kopieren und Weiterleiten von Dokumenten:</p>
                <span class="row pl-2">= (Anzahl an Dokumenten)</span>
                <span class="row pl-2">x (Zeiteinsparung pro Dokument)</span>
                <p class="row pl-2">x (20 Arbeitstage)</p>
                <p class="row pl-2">(Die angenommene Zeit für das Ablegen, Suchen, Kopieren und Verteilen von Dokumenten
                  mit DocuWare liet bei 30 Sekunden je Dokument und Tätigkeit)</p>
                <p class="row pl-2">Zeiteinsparung bei der Wiederherstellung:</p>
                <span class="row pl-2">= (Anzahl an Dokumenten)</span>
                <span class="row pl-2">x (Dauer der Wiederherstellung)</span>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
        <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Allgemeine Zeitersparungen</h4>
          <form class="needs-validation" novalidate>
            <div class="row">
              <div class="col-md-8">
                <label for="filedDay">Wie viele Dokumente werden täglich abgelegt?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="filedDay" min="1" [(ngModel)]="filedDay" name="filedDay" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="filedDayTime">Wie lange dauert es in der Regel, ein Dokument abzulegen? (in Minuten)</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="filedDayTime" min="1" [(ngModel)]="filedDayTime" name="filedDayTime" (ngModelChange)="calcTimes()" value="3" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="searchDay">Wie viele Dokumente werden täglich gesucht?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="searchDay" min="1" [(ngModel)]="searchDay" name="searchDay" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="searchDayTime"> Wie lange dauert es, ein Dokument zu suchen?</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="searchDayTime" min="1" [(ngModel)]="searchDayTime" name="searchDayTime" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="copyDay">Wie viele Dokumente werden täglich kopiert?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="copyDay" min="1" [(ngModel)]="copyDay" name="copyDay" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="copyDayTime">Wie lange dauert es, ein Dokument zu kopieren?</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="copyDayTime" min="1" [(ngModel)]="copyDayTime" name="copyDayTime" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="anzMember">Wie viele Mitarbeiter hat Ihre Organisation?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="anzMember" min="1" [(ngModel)]="anzMember" name="anzMember" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="anzMemberTime">Wie viel Zeit verwendet jeder Ihrer Mitarbeiter täglich für die Organisation von Dokumenten?</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="anzMemberTime" min="1" [(ngModel)]="anzMemberTime" name="anzMemberTime" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="anzRestore">Wie viele verlorene oder verlegte Dokumente müssen monatlich wiederhergestellt werden?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="anzRestore" min="1" [(ngModel)]="anzRestore" name="anzRestore" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="anzRestoreTime"> Wie lange dauert es, ein verlorenes oder verlegtes Dokument wiederherzustellen/wiederzufinden? (in Minuten)</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="anzRestoreTime" min="1" [(ngModel)]="anzRestoreTime" name="anzRestoreTime" (ngModelChange)="calcTimes()" required>
              </div>
            </div>
            <hr class="mb-4">
            <button type="button" class="btn btn-secondary" previousStep>Zurück</button>
            <button type="button" class="btn btn-primary" nextStep>Weiter</button>
          </form>
        </div>
      </div>
    </div>
  </wizard-step>

  <wizard-step stepTitle="Ressourcen" navigationSymbol="&#xf2b9;" navigationSymbolFontFamily="FontAwesome">
    <div class="container">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
      </div>
      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <ngb-accordion [closeOthers]="true" activeIds="static-1">
            <ngb-panel id="static-1" title="Ergebnis">
              <ng-template ngbPanelContent>
                Ihre Organistation könnte bei den einzelnen Tätigkeiten monatlich folgende Kosten einsparen:
                <div class="row pt-1">
                  <div class="col-md-4 left">Ablage:</div>
                  <div class="col-md-8 right">{{ anzSquareCalc | currency:'EUR'  }} </div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Versand:</div>
                  <div class="col-md-8 right">{{ shipping | currency:'EUR'  }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Kopieren:</div>
                  <div class="col-md-8 right">{{ photocopyCalc | currency:'EUR'  }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-4 left">Drucken:</div>
                  <div class="col-md-8 right">{{ printCalc | currency:'EUR'  }}</div>
                </div>
                <div class="row pt-3">
                  <div class="col-md-4 left font-weight-bold">Summe:</div>
                  <div class="col-md-8 right font-weight-bold">{{ sumRessource | currency:'EUR'  }}</div>
                </div>
              </ng-template>
            </ngb-panel>
            <ngb-panel id="static-2" title="So wird gerechnet">
              <ng-template ngbPanelContent>
                <p class="row pl-2">Mieteinsparung:</p>
                <span class="row pl-2">= (Eingesparte Fläche)</span>
                <span class="row pl-2">x (Monatlicher Mietpreis)</span>
                <p class="row pl-2">Versandkosten</p>
                <p class="row pl-2">Einsparung von Kopier- und Druckkosten bei der Wiederherstellung:</p>
                <span class="row pl-2">= (Anzahl an Dokumenten)</span>
                <span class="row pl-2">x (Preis pro Kopie/Ausdruck)</span>
                <span class="row pl-2">x (20 Arbeitstage)</span>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
        <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Allgemeine Ressourcen</h4>
          <form class="needs-validation" novalidate>
            <div class="row">
              <div class="col-md-8">
                <label for="anzSquare">Wie viel Archivraum halten Sie für die Lagerung Ihrer Dokumente vor?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="anzSquare" min="1" [(ngModel)]="anzSquare" name="anzSquare" (ngModelChange)="calcRessource()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="monthSquarceCost">Wie hoch sind Ihre monatlichen Mietkosten (pro Quadratmeter) für den vorgehaltenen Archivraum?</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control disabled" id="monthSquarceCost" min="1" [(ngModel)]="monthSquarceCost" name="monthSquarceCost" (ngModelChange)="calcRessource()" value="3" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="shipping">Wie hoch beziffern Sie Ihre monatlichen Versandkosten?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control" id="shipping" min="1" [(ngModel)]="shipping" name="shipping" (ngModelChange)="calcRessource()" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="photocopyPrice">Wie hoch beziffern Sie die Kosten für eine Kopie?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control disabled" id="photocopyPrice" min="1" [(ngModel)]="photocopyPrice" name="photocopyPrice" (ngModelChange)="calcRessource()" required>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="printPrice">Wie hoch beziffern Sie die Kosten für das Ausdrucken einer Seite?</label>
              </div>
              <div class="col-md-2 mb-1">
                <input type="number" class="form-control disabled" id="printPrice" min="1" [(ngModel)]="printPrice" name="printPrice" (ngModelChange)="calcRessource()" required>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="anzPrint">Wie viele Seiten werden täglich gedruckt und abgelegt?</label>
              </div>
              <div class="col-md-2">
                <input type="number" class="form-control" id="anzPrint" min="1" [(ngModel)]="anzPrint" name="anzPrint" (ngModelChange)="calcRessource()" required>
              </div>
            </div>
            <hr class="mb-4">
            <button type="button" class="btn btn-secondary" previousStep>Zurück</button>
            <button type="button" class="btn btn-primary" nextStep>Weiter</button>
          </form>
        </div>
      </div>
    </div>
  </wizard-step>

  <wizard-step stepTitle="Allgemeinkosten" navigationSymbol="&#xf19c;" navigationSymbolFontFamily="FontAwesome">
    <div class="container">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
      </div>
      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <ngb-accordion [closeOthers]="true" activeIds="static-1">
            <ngb-panel id="static-1" title="Ergebnis">
              <ng-template ngbPanelContent>
                Ihre Organistation könnte bei folgende Kosten einsparen:
                <div class="row pt-1">
                  <div class="col-md-8 left">Eingesparte Ressourcen:</div>
                  <div class="col-md-4 right">{{ sumRessource | currency:'EUR' }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-8 left">Kostenreduzierung:</div>
                  <div class="col-md-4 right">{{ sumPersonal | currency:'EUR' }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-8 left">Gewinnpotential:</div>
                  <div class="col-md-4 right">{{ sumActivity | currency:'EUR' }}</div>
                </div>
                <div class="row pt-3">
                  <div class="col-md-8 left font-weight-bold">Summe:</div>
                  <div class="col-md-4 right font-weight-bold">{{ sumCost | currency:'EUR' }}</div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
        <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Allgemeinkosten</h4>
          <div class="row">
            <div class="col-md-8">
              <label>Eingesparte Ressourcen:</label>
            </div>
            <div class="col-md-2 mb-1 font-weight-bold">
              {{ sumRessource | currency:'EUR' }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <label>Eingesparte Zeit:</label>
            </div>
            <div class="col-md-4 mb-3 font-weight-bold">
              {{ sumHour }} Stunden  {{ sumMinute }} Minuten
            </div>
          </div>
          <form class="needs-validation" novalidate>
            <h6 class="mb-3">Kostenreduzierungpotenzial - Personalkosten</h6>
            <div class="row">
              <div class="col-md-8">
                <label for="anzPersonal">Welchen Prozentsatz der noch zur Verfügung stehenden Zeit können Sie verwenden, um Ihre Personalkosten zu reduzieren?</label>
              </div>
              <div class="col-md-3 mb-2 input-group unity-input">
                <input type="number" class="form-control" id="anzPersonal" min="1" [(ngModel)]="anzPersonal" name="anzPersonal" (ngModelChange)="calcResult()" required>
                <span class="input-group-addon" id="anzPersonal_label">%</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <label for="personalPrice">Wie hoch beziffern Sie Ihre Personalkosten pro Stunde?</label>
              </div>
              <div class="col-md-3 mb-2 input-group unity-input">
                <input type="number" class="form-control" id="personalPrice" min="1" [(ngModel)]="personalPrice" name="personalPrice" (ngModelChange)="calcResult()" value="3" required>
                <span class="input-group-addon" id="personalPrice_label">€</span>
              </div>
            </div>
            <h6 class="mb-3 mt-1">Gewinnpotential - Umverteilung von Ressourcen</h6>
            <div class="row mt-4">
              <div class="col-md-8">
                <label for="anzActivity">Welchen Prozentsatz der errechneten Zeitersparnis könnten Sie nach erster Einschätzung für andere Tätigkeiten einsetzen?</label>
              </div>
              <div class="col-md-3 mb-2 input-group unity-input">
                <input type="number" class="form-control" id="anzActivity" min="1" [(ngModel)]="anzActivity" name="anzActivity" (ngModelChange)="calcResult()" required>
                <span class="input-group-addon" id="anzActivity_label">%</span>
              </div>
            </div>
            <div class="row mt-1">
              <div class="col-md-8">
                <label for="activityPrice">Gewinnpotential pro Stunde?</label>
              </div>
              <div class="col-md-3 mb-2 input-group unity-input">
                <input type="number" class="form-control" id="activityPrice" min="1" [(ngModel)]="activityPrice" name="activityPrice" (ngModelChange)="calcResult()" required>
                <span class="input-group-addon" id="activityPrice_label">€</span>
              </div>
            </div>
            <hr class="mb-4">
            <button type="button" class="btn btn-secondary" previousStep>Zurück</button>
            <button type="button" class="btn btn-primary" nextStep>Weiter</button>
          </form>
        </div>
      </div>
    </div>
  </wizard-step>

  <wizard-step stepTitle="Berechnung" navigationSymbol="&#xf1ec;" navigationSymbolFontFamily="FontAwesome">
    <div class="container">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
      </div>
      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <ngb-accordion [closeOthers]="true" activeIds="static-1">
            <ngb-panel id="static-1" title="Ergebnis">
              <ng-template ngbPanelContent>
                Ihre Organistation könnte bei folgende Kosten einsparen:
                <div class="row pt-1">
                  <div class="col-md-8 left">Eingesparte Ressourcen:</div>
                  <div class="col-md-4 right">{{ sumRessource | currency:'EUR' }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-8 left">Kostenreduzierung:</div>
                  <div class="col-md-4 right">{{ sumPersonal | currency:'EUR' }}</div>
                </div>
                <div class="row pt-1">
                  <div class="col-md-8 left">Gewinnpotential:</div>
                  <div class="col-md-4 right">{{ sumActivity | currency:'EUR' }}</div>
                </div>
                <div class="row pt-3">
                  <div class="col-md-8 left font-weight-bold">Summe:</div>
                  <div class="col-md-4 right font-weight-bold">{{ sumCost | currency:'EUR' }}</div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
        <div class="col-md-8 order-md-1">
          <div class="container">
            <div class="card-deck mb-3 text-center">
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">Amortisationsdauer</h4>
                </div>
                <div class="card-body">
                  <div class="row ml-4">
                    <label for="invest">Potenzielle Investition</label>
                  </div>
                  <div class="row ml-4 mb-4 mr-5">
                    <input type="number" class="form-control" id="invest" min="1" [(ngModel)]="invest" name="invest" required>
                  </div>
                  <button type="button" class="btn btn-lg btn-block btn-outline-primary" (click)="showInvest()">Ergebnis anzeigen</button>
                </div>
              </div>
              <div class="card mb-4 box-shadow">
                <div class="card-header">
                  <h4 class="my-0 font-weight-normal">Potenzielle Investition</h4>
                </div>
                <div class="card-body">
                  <div class="row ml-4">
                    <label for="period">Amortisationsdauer</label>
                  </div>
                  <div class="row ml-4 mb-4 mr-5">
                    <input type="number" class="form-control" id="period" min="1" [(ngModel)]="period" name="period" required>
                  </div>
                  <button type="button" class="btn btn-lg btn-block btn-outline-primary" (click)="showPeriod()">Ergebnis anzeigen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </wizard-step>

  <wizard-step stepTitle="Armortisationsdauer" navigationSymbol="&#xf00c;" navigationSymbolFontFamily="FontAwesome">
    <div class="container">
      <div class="py-5 text-center">
        <img class="d-block mx-auto mb-4" src="assets/img/logo.jpg" alt="" width="227" height="52">
      </div>

      <div class="centered-content">
        <div *ngIf="isShowInvest">
          <h5>Amortisationszeitpunkt Ihrer DocuWare-Investition:</h5>
          <div class="row">
            <div class="col-md-8">
              <label for="anzActivity">Summe der montalichen Einsparung?</label>
            </div>
            <div class="col-md-2">
              {{ sumCost | currency:'EUR' }}
            </div>
          </div>
          <div class="row mt-2" >
            <div class="col-md-8">
              <label for="anzActivity">Potenzielle Investition:</label>
            </div>
            <div class="col-md-2">
              {{ invest | currency:'EUR' }}
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-8 font-weight-bold">
              <label for="anzActivity">Berechnete Amortisationsdauer:</label>
            </div>
            <div class="col-md-2 font-weight-bold">
              {{ month | number:'1.1-1'}} Monate
            </div>
          </div>
        </div>
        <div *ngIf="isShowPeriod">
          <h5>Mögliches Einsparpotential pro Monat durch den Einsatz von DocuWare in Ihrem Unternehmen:</h5>
          <div class="row">
            <div class="col-md-8">
              <label for="anzActivity">Summe der montalichen Einsparung?</label>
            </div>
            <div class="col-md-2">
              {{ sumCost | currency:'EUR' }}
            </div>
          </div>
          <div class="row mt-2" >
            <div class="col-md-8">
              <label for="anzActivity">Amortisationsdauer:</label>
            </div>
            <div class="col-md-2">
              {{ period  }} Monate
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-8 font-weight-bold">
              <label for="anzActivity">Potenzielle Investition:</label>
            </div>
            <div class="col-md-2 font-weight-bold">
              {{ price | currency:'EUR' }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-8 order-md-1">
            <canvas id="canvas"></canvas>
          </div>
        </div>

        <hr class="mb-4">
        <button type="button" class="btn btn-secondary" previousStep>Zurück</button>
        <button type="button" class="btn btn-primary" (click)="restart()" resetWizard>Neustart</button>
      </div>
    </div>
  </wizard-step>
</wizard>

<footer class="my-5 pt-3 text-muted text-center text-small">
  <p class="mb-1">&copy; 2018 ikt Gromnitza GmbH & Co KG</p>
  <ul class="list-inline">
    <li class="list-inline-item"><a href="https://gromnitza.de/impressum.html" target="_blank">Impressum</a></li>
    <li class="list-inline-item"><a href="https://gromnitza.de/datenschutz.html" target="_blank">Datenschutz</a></li>
    <li class="list-inline-item"><a href="https://gromnitza.de/kontakt.html" target="_blank">Support</a></li>
  </ul>
</footer>




// WEBPACK FOOTER //
// C:/Users/newan/PhpstormProjects/GromnitzaRoi/src/app/app.component.html